module.exports = __webpack_public_path__ + "static/img/m_faq_articles_icon@3x.fcae125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_faq_articles_icon@3x.png
// module id = FB0d
// module chunks = 1